<template>
    <div class="container-main">
        <div class="container-main-header-button">
            <v-btn depressed @click="back">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <span>Редактирование</span>
        </div>
        <v-form ref="formFirst">
            <div class="container-block">
                <div class="container-block-title">
                    Информация об акционере
                </div>
                <div>
                    <v-text-field label="ФИО" required type="text" outlined :rules="rules"
                        v-model="item.fullName"></v-text-field>
                </div>

                <div>
                    <v-textarea label="Биография" required no-resize type="text" outlined :rules="rules"
                        v-model="item.biography" rows="10"></v-textarea>
                </div>

            </div>
        </v-form>

        <div class="container-block">
            <div class="container-block-title">
                Активности акционера
            </div>
            <div class="d-flex" v-for="(i, index) in activities" :key="index">
                <v-text-field :label='i.name' required type="text" outlined v-model="i.value"></v-text-field>

            </div>

        </div>


        <div v-if="!newImage" class="container-block">
            <div class="container-block-title">
                Фотография акционера
            </div>

            <v-file-input accept="image/*" outlined
                :rules="[value => (value && value.size < 104857600) || 'Размер изображения не больше 100 мб']"
                hint="Максимальный размер изображения 100 мб" persistent-hint v-model="newImage" @change="previewImage"
                label="Прикрепить изображение"></v-file-input>
            <div class="container-block-gallery-button">
                Выбрать изображение из галереи
            </div>

        </div>



        <div>



        </div>




        <div v-if="newImage" class="container-block" style="width: 100%">
            <div class="container-block-title">
                Кадрировать изображение
            </div>
            <div class="container-block-subtitle">
                Кадрирование является опциональным
            </div>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">
                                Формат
                            </th>
                            <th class="text-left">
                                Место отображенния
                            </th>
                            <th class="text-left">
                                Для смартфонов
                            </th>
                            <th class="text-left">
                                Для планшетов
                            </th>
                            <th class="text-right">

                            </th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr style="height: 60px;" v-if="newImage">
                            <td class="text-left">Фото</td>
                            <td class="text-left">Отображается в списке «Состав» в разделе КСА</td>
                            <td class="text-left">
                                <v-btn v-if="!finishImageMobile" @click="openMobileImg(false)" class="button-accept"
                                    style="width: auto !important">
                                    Кадрировать
                                </v-btn>

                                <div v-else class="d-flex">
                                    <img @click="openMobileImg(false)" class="table-img" :src="finishImageMobile">
                                    <v-btn outlined @click="openMobileImg(false)" color="var(--app-dark-blue-1) "
                                        class="button-accept-outlined" style="width: auto !important; margin-left: 10px">
                                        Изменить
                                    </v-btn>
                                </div>

                            </td>
                            <td class="text-left">
                                <v-btn v-if="!finishImageTablet" @click="openTabletImg(false)" class="button-accept"
                                    style="width: auto !important">
                                    Кадрировать
                                </v-btn>
                                <div v-else class="d-flex">
                                    <img @click="openTabletImg(false)" class="table-img" :src="finishImageTablet">
                                    <v-btn outlined @click="openTabletImg(false)" color="var(--app-dark-blue-1) "
                                        class="button-accept-outlined" style="width: auto !important; margin-left: 10px">
                                        Изменить
                                    </v-btn>
                                </div>


                            </td>
                            <td class="text-left">
                                <v-btn icon @click="deleteImage">
                                    <v-icon color="var(--app-red-1)">
                                        mdi-delete-outline
                                    </v-icon>
                                </v-btn>

                            </td>
                        </tr>


                    </tbody>
                </template>
            </v-simple-table>
            <v-alert color="var(--app-red-1)" type="error" v-model="errImages">
                Откадрируйте изображения для всех типов устройств


            </v-alert>
            <v-divider></v-divider>



            <v-dialog width="800px" height="auto" persistent v-if="imgSrc" v-model="dialogMobile">
                <v-card width="800px" height="auto" class="rounded-0">
                    <v-card-title class="dialog-title">
                        <span class="title">Кадрирование изображения</span>
                        <v-icon @click="dialogMobile = false;">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-text class="dialog-description">
                        <div class="dialog-subtitle">
                            <div class="dialog-subtitle-title">
                                Отображение на мобильном устройстве
                            </div>
                            <div class="dialog-subtitle-text">
                                Вы можете изменять размер изображения с помощью колесика мыши и двигать его.
                            </div>
                        </div>

                        <div v-if="imgSrc" class="d-flex justify-space-between">
                            <div style="width: 380px;  height: 380px;">
                                <cropper ref="cropperMobail" :src="imgSrc" style="width: 450px;  height: 450px;"
                                    :stencil-props="{
                                        handlers: {},
                                        movable: false,
                                        scalable: true,

                                    }" :stencil-size="{
    width: 76,
    height: 84
}" image-restriction="stencil" @change="onChangeMobile" />
                            </div>


                            <div class="d-flex justify-center" style="width: 100%;" v-if="resultImageMobile">
                                <img width="76px" height="84px" :src="resultImageMobile">
                            </div>

                        </div>


                    </v-card-text>
                    <v-card-actions class="dialog-buttons">
                        <v-btn @click="closeMobileImg()" class="button-accept">
                            Сохранить
                        </v-btn>

                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog width="800px" height="auto" persistent v-if="imgSrc" v-model="dialogTablet">
                <v-card width="800px" height="auto" class="rounded-0">
                    <v-card-title class="dialog-title">
                        <span class="title">Кадрирование изображения</span>
                        <v-icon @click="dialogTablet = false;">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-text class="dialog-description">
                        <div class="dialog-subtitle">
                            <div class="dialog-subtitle-title">
                                Отображение на планшете
                            </div>
                            <div class="dialog-subtitle-text">
                                Вы можете изменять размер изображения с помощью колесика мыши и двигать его.
                            </div>
                        </div>

                        <div v-if="imgSrc" class="d-flex justify-space-between">
                            <div style="width: 380px;  height: 380px;">
                                <cropper ref="cropperTablet" :src="imgSrc" style="width: 450px;  height: 450px;"
                                    :stencil-props="{
                                        handlers: {},
                                        movable: false,
                                        scalable: true,

                                    }" :stencil-size="{
    width: 90,
    height: 100
}" image-restriction="stencil" @change="onChangeTablet" />
                            </div>


                            <div class="d-flex justify-center" style="width: 100%;" v-if="resultImageTablet">
                                <img width="90px" height="100px" :src="resultImageTablet">
                            </div>

                        </div>


                    </v-card-text>
                    <v-card-actions class="dialog-buttons">
                        <v-btn @click="closeTabletImg()" class="button-accept">
                            Сохранить
                        </v-btn>

                    </v-card-actions>
                </v-card>
            </v-dialog>



        </div>
        <v-alert color="var(--app-red-1)" type="error" v-model="errImagesMain">
            Прикрепите изображение

        </v-alert>


        <div class="container-block-footer-buttons">
            <div>
                <v-btn @click="saveShareholder" style="width: auto !important" class="button-accept">
                    Сохранить
                </v-btn>

            </div>
            <div>
                <v-btn @click="dialogDelete = true;" outlined style="width: auto !important" color="var(--app-red-1)"
                    class="button-accept-outlined">
                    Удалить
                </v-btn>
            </div>
        </div>
        <v-dialog width="600px" height="auto" persistent v-model="dialogDelete">
            <v-card>
                <v-card-title class="dialog-title">
                    <span class="title">Точно хотите удалить акционера?</span>
                    <v-icon @click="dialogDelete = false;">mdi-close</v-icon>
                </v-card-title>
                <v-card-actions class="dialog-buttons">
                    <v-btn @click="dialogDelete = false;" style="width: 120px" outlined color="var(--app-green-1)">
                        Нет
                    </v-btn>
                    <v-btn @click="deleteItem" style="width: 120px" outlined color="var(--app-red-1)">
                        Да
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>
<script>

import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

const ACTIVITY_EVENT_COUNT_NAME = 'Количество мероприятий'

export default {
    components: {
        Cropper
    },
    data: () => ({
        item: {},
        activities: [],
        errImages: false,
        errImagesMain: false,
        dialogMobile: false,
        dialogTablet: false,
        dialogDelete: false,

        rules: [value => !!value || 'Обязательно к заполнению'],

        newImage: null,
        imgSrc: '',


        resultImageMobile: '',
        resultImageTablet: '',

        finishImageMobile: '',
        finishImageTablet: '',



        smartphoneMainImage: null,
        tabletMainImage: null,
        formData: new FormData()



    }),


    methods: {

        deleteImage() {
            this.newImage = null
            this.imgSrc = ''
            this.resultImageMobile = ''
            this.resultImageTablet = ''
            this.finishImageMobile = ''
            this.finishImageTablet = ''
            this.smartphoneMainImage = null
            this.tabletMainImage = null


        },

        openMobileImg() {


            this.dialogMobile = true
            setTimeout(() => {
                this.$refs.cropperMobail.refresh()
            }, 500)


            this.errImages = false
        },
        openTabletImg() {
            this.dialogTablet = true
            setTimeout(() => {
                this.$refs.cropperTablet.refresh()
            }, 500)
            this.errImages = false
        },
        closeTabletImg() {

            this.finishImageTablet = this.resultImageTablet
            this.dialogTablet = false
            const { canvas } = this.$refs.cropperTablet.getResult();
            canvas.toBlob(blob => {
                this.formData.append('tabletImage', blob);

            }, 'image/webp', 0.95);
            this.tabletMainImage = true

        },

        closeMobileImg() {

            this.finishImageMobile = this.resultImageMobile
            this.dialogMobile = false
            const { canvas } = this.$refs.cropperMobail.getResult();
            canvas.toBlob(blob => {
                this.formData.append('smartphoneImage', blob);

            }, 'image/webp', 0.95);
            this.smartphoneMainImage = true


        },

        back() {
            this.$router.push({ name: 'DetailShareholder', params: { id: this.$route.params.id } })
        },

        previewImage() {

            if (this.newImage) {

                this.imgSrc = URL.createObjectURL(this.newImage)
            }
            else {
                this.imgSrc = ''
            }
        },

        defaultSize({ imageSize }) {
            return {
                width: Math.min(imageSize.height, imageSize.width),
                height: Math.min(imageSize.height, imageSize.width),
            };
        },


        onChangeMobile({ canvas }) {
            this.resultImageMobile = canvas.toDataURL()
        },

        onChangeTablet({ canvas }) {
            this.resultImageTablet = canvas.toDataURL()


        },
        deleteItem() {
            this.$axios.delete(this.$store.getters.apiAdminPanelV2 + '/shareholder', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    shareholderId: this.$route.params.id
                }
            })
                .then(() => {
                    this.$router.push({ name: 'Shareholders' })
                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        getShareholder() {
            this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/shareholder', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    shareholderId: this.$route.params.id
                }
            })
                .then(res => {
                    this.item = res.data
                    this.activities = (res.data.activities || []).filter(activity => activity.name !== ACTIVITY_EVENT_COUNT_NAME)
                    this.newImage = res.data.originalImage
                    this.smartphoneMainImage = res.data.smartphoneImage
                    this.tabletMainImage = res.data.tabletImage
                    this.imgSrc = res.data.originalImage
                    this.finishImageMobile = res.data.smartphoneImage
                    this.finishImageTablet = res.data.tabletImage


                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },

        saveShareholder() {


            if (this.$refs.formFirst.validate()) {
                if (this.newImage) {
                        this.errImages = false

                        if (this.newImage instanceof File || this.newImage instanceof Blob) {
                            if (!this.formData.has('smartphoneImage')) {
                                this.formData.append('smartphoneImage', this.newImage)
                            }
                            if (!this.formData.has('tabletImage')) {
                                this.formData.append('tabletImage', this.newImage)
                            }
                        }

                        this.formData.append('shareholderId', this.item.id)
                        this.formData.append('fullName', this.item.fullName || '')
                        this.formData.append('biography', this.item.biography || '')

                        this.formData.append('activities', JSON.stringify(this.activities))

                        this.formData.append('originalImage', this.newImage || null)




                        this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/shareholder', this.formData, {
                            headers: {
                                'authorization': this.$store.getters.adminPanelHeaderAuth
                            }
                        })
                            .then(() => {
                                this.$router.push({ name: 'Shareholders' })


                            })
                            .catch(err => {
                                this.$store.commit('errorSet', true)
                                this.$store.commit('errorTextSet', err)
                            })

                }
                else {
                    this.errImagesMain = true
                }

            }

        }

    },
    created() {
        this.getShareholder()
    },

    watch: {
        newImage() {
            if (this.newImage) {
                this.errImagesMain = false
            }
        },

    }
}
</script>
<style lang="scss" scoped>
.container-main {
    box-sizing: border-box;

    padding: 40px !important;

    .container-main-header-button {
        display: flex;
        align-items: center;
        margin-bottom: 30px;

        span {
            font-size: 28px;
            font-weight: 400;
            margin-left: 16px;
        }
    }

    .container-block {
        width: 50%;
        margin-bottom: 20px;

        .container-block-title {
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 16px;

        }

        .container-block-subtitle {
            font-size: 14px;
            color: #929292;
            margin-top: -8px;
            margin-bottom: 16px;
        }

        .container-block-gallery-button {
            text-decoration: underline;
            color: #1064DD;
            font-size: 18px;
            font-weight: 400;
            cursor: pointer;
            padding-bottom: 20px;
        }

        .table-img {
            // width: 62px;
            height: 38px;
            object-fit: contain;
        }

    }

    .container-block-footer-buttons {
        display: flex;
        justify-content: space-between;
        width: 50%;
        margin-top: 60px;
    }

}


.fade-enter-active,
.fade-leave-active {
    transition: opacity 2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active до версии 2.1.8 */
    {
    opacity: 0;
}
</style>
